import createIcon from '../../createIcon';

/**
 * @component @name FirstPage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguMjA0OSAxNi41OUwxMy42MTQ5IDEyTDE4LjIwNDkgNy40MUwxNi43OTQ5IDZMMTAuNzk0OSAxMkwxNi43OTQ5IDE4TDE4LjIwNDkgMTYuNTlaTTUuNzk0OTIgNkg3Ljc5NDkyVjE4SDUuNzk0OTJWNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FirstPage = createIcon('FirstPage', [
  [
    'path',
    {
      d: 'M18.2049 16.59L13.6149 12L18.2049 7.41L16.7949 6L10.7949 12L16.7949 18L18.2049 16.59ZM5.79492 6H7.79492V18H5.79492V6Z',
      key: 'm8elg',
    },
  ],
]);

export default FirstPage;
